import { FormTypes } from '@oneblink/types'
import { postRequest } from './http'
import config from '../config'

export async function createTrackingCode(
  form: FormTypes.Form,
  existingTrackingCode?: string,
) {
  const { trackingCode } = await postRequest<{ trackingCode: string }>({
    url: `${config.HOSTED_API_URL}/submissions/submission/create-tracking-code`,
    resource: {
      trackingCode: existingTrackingCode,
      formsAppId: config.FORMS_APP_ID,
      formId: form.id,
    },
    addAuthHeaders: form.isAuthenticated,
  })
  return trackingCode
}
